import { TableColumnDef } from 'app/shared/tables/table-column-def';

export interface SettingsModel {
    envName: string;
    url: string;
    tenant: string;
    clientId: string;
    customerName: string;
    appInsightsInstrumentationKey: string;
}

export interface CommandResult {
    success: boolean;
    objectId: string;
    commandName: string;
}

export interface CommandResultInfo {
    completed: boolean;
    commandName: string;
    result: any;
}

export interface CommandDataviewResult {
    value: Array<{}>;
}

export class TableResponseQuery<T = any> {
    items: T[];
    total_count: number;

    constructor(itemsList: T[], count: number) {
        this.items = itemsList;
        this.total_count = count;
    }
}

export class SieveTableResponseQuery {
    items: any[];
    metadata: SieveMetaData;

    constructor(itemsList: any[], metadata: SieveMetaData) {
        this.items = itemsList;
        this.metadata = metadata;
    }
}

class SieveMetaData {
    totalItems: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;

    constructor(
        totalItems: number,
        pageNumber: number,
        pageSize: number,
        totalPages: number
    ) {
        this.totalItems = totalItems;
        this.pageNumber = pageNumber;
        this.pageSize = pageSize;
        this.totalPages = totalPages;
    }
}

export class CategoryQueryModel {
    Id: number;
    InternalId: number;
    Name: string;
    ParentId: number;
    Level: number;
    CategoryMap: Array<any>;
}

export class FiltersQueryModel {
    filters: {
        CategoryNamesLevel1: Array<string>;
        CategoryNamesLevel2: Array<string>;
        CategoryNamesLevel3: Array<string>;
        Suppliers: Array<string>;
        SimulationScenerioOwners: Array<string>;
        VatRates: Array<string>;
        ProductSensitivites: Array<string>;
        ProductCategoryRoles: Array<string>;
        CategoryRoles?: Array<string>;
        ProductsStatus: Array<string>;
        SimulationAlerts: Array<string>;
        Categories: CategoriesTree[];
    };
}

export interface CategoriesTreeFlatList {
    id: number;
    name?: string;
    parentId?: number;
}

export interface CategoriesTree {
    id: number;
    label: string;
    parentId: number;
    children: CategoriesTree[];
    leaf: boolean;
    level?: number;
}

export enum FiltersEnum {
    CategoryNamesLevel1 = 'CategoryNameLevel1',
    CategoryNamesLevel2 = 'CategoryNameLevel2',
    CategoryNamesLevel3 = 'CategoryNameLevel3',
    Suppliers = 'Manufacturer',
    SimulationScenerioOwners = 'OwnerName',
    VatRates = 'VatOfSales',
    ProductSensitivites = 'Sensitivity',
    ProductCategoryRoles = 'ProductCategory',
    CategoryRoles = 'CurrentRole',
    BasketOwners = 'OwnerDisplayName',
    StoreCities = 'City',
    StoreRegions = 'Region0',
    CompStoreCities = 'City',
    CompStoreRegions = 'Region0',
    CompStoreNames = 'CompStoreName',
    StoreNumbers = 'StoreNumber',
    ProductsStatus = 'Status',
    SimulationAlerts = 'SimulationAlerts',
    Status = 'ProductsStatus',
    SensitivityTranslate = 'ProductSens',
    EANs = 'EAN',
    ProductEan = 'ProductEan',
    Codes = 'Code',
    Id = 'Id',
    Categories = 'Categories'
}

export enum FilterSimulResultsAlertsEnum {
    Exist = 'Istnieje',
    Noexist = 'Nie istnieje',
}

export enum StatusLangEnum {
    Active = 'Aktywny',
    InActive = 'Nieaktywny',
}

export class FilterOutputModel {
    filterValues: Array<any>;
    filterName: string;
    columnDef: TableColumnDef;
}

export enum PriceRoles {
    trafficBuilder = 'TrafficBuilder',
    regular = 'Regular',
    basic = 'Basic',
}

export enum PriceRolesEnum {
    trafficBuilder = 0,
    regular = 1,
    basic = 2,
}

export enum PriceSens {
    VerySensitive = 'VerySensitive',
    Sensitive = 'Sensitive',
    Insensitive = 'Insensitive',
}

export enum PriceSensEnum {
    VerySensitive = 1,
    Sensitive = 2,
    Insensitive = 3,
}

export class JobStatusModel {
    State: string;
    Status: string;
}

export class XlsxResponseModel {
    blob: Blob;
    titleHeader: string;
}

export enum PriceSensPolishEnum {
    VerySensitive = 'Bardzo wrażliwe',
    Sensitive = 'Wrażliwe',
    Insensitive = 'Niewrażliwe',
}
